module.exports = __webpack_public_path__ + "img/04.49b258eb.jpg";